import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
export interface VirusQueryParams {
  start_time: Date // 开始时间
  end_time: Date // 结束时间
  only_untreated: boolean // 仅看未处理
  key_word: string // 关键词搜索
  page: number // 页码
  limit: number // 每页数量
  cascade_team_id: number // 级联团队id
  sort: string // 排序字段名
  asc: boolean // true-正序，false-逆序
  /** 处理状态：0-全部，1-未处理，2-已处理，4-已信任（与 logmanage/virus-scan/stat 一致） */
  handle_status?: number
  /** 风险类型 */
  risk_type?: number
  /** 风险项，-1 表示全部 */
  risk_item?: number
  /** 查杀方式：1 闪电 2 全盘 3 主动防御 4 自定义 */
  scan_type?: number
}

export interface VirusItem {
  client_ip: string // 外网IP
  system_ip: string // 内网IP
  computer_name: string
  user_mark: string
  group_name: string
  risk_type: string // 风险类型
  risk_item: number // 风险项
  risk_name: number // 风险名
  scan_type: string // 类型
  scan_time: number // 发现时间
  handle_time: number // 处理时间
  virus_info: string // 病毒详情
  /** 终端状态，1：在线，2：离线 */
  device_status: string
  /** 系统类型 1-windows 2-linux */
  system_type?: number
}

@Injectable()
export class VirusViewService {
  constructor (private http: Http) {
  }

  @ParamsClean()
  @InvokeThrottle()

  fetchVirusList (options: VirusQueryParams) {
    return this.http
      .post<{
        total: number,
        list: VirusItem[]
      }>('logmanage/virus-scan/stat', options)
  }
  @ParamsClean([0], 1)
  download (type: 0|1, options: VirusQueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/logmanage/virus-scan/stat/export', params, moduleName)
  }
}
